const Phone = {
    name: 'PHONE',
    options: {
        regexp: '^[1-9]{1}[0-9]{0,8}$',
        numberOfDigits: 9
    }
};

export default Phone;
